export const getPaginationRange = (currentPage, totalPages) => {
  const totalPageNumbersToShow = 5;
  const totalPageNumbers = totalPageNumbersToShow + 2; // including first and last

  if (totalPages <= totalPageNumbers) {
    return [...Array(totalPages).keys()].map((n) => n + 1);
  }

  const leftSiblingIndex = Math.max(currentPage - 1, 2);
  const rightSiblingIndex = Math.min(currentPage + 1, totalPages - 1);

  const shouldShowLeftDots = leftSiblingIndex > 2;
  const shouldShowRightDots = rightSiblingIndex < totalPages - 1;

  const pagination = [1];

  if (shouldShowLeftDots) {
    pagination.push('...');
  }

  for (let i = leftSiblingIndex; i <= rightSiblingIndex; i++) {
    pagination.push(i);
  }

  if (shouldShowRightDots) {
    pagination.push('...');
  }

  pagination.push(totalPages);

  return pagination;
};
